module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"user_display_name_message_html":"<b>%{user_display_name}</b>的评论。","user_grade":"用户等级","author_grade":"创建者等级"}}')
  delete Component.options._Ctor
}
